import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n";
import GlobalTranslator from "@/i18n/GlobalTranslator";
import FloatingLanguageSwitcher from "@/components/site/FloatingLanguageSwitcher";
import { MessagingProvider } from "@/context/MessagingContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/site/Home";
import Book from "@/pages/site/Book";
import SecondOpinion from "@/pages/site/SecondOpinion";
import Journal from "@/pages/site/Journal";
import Specialties from "@/pages/site/Specialties";
import SpecialtyDetail from "@/pages/site/SpecialtyDetail";
import DoctorProfile from "@/pages/site/DoctorProfile";
import Services from "@/pages/site/Services";
import About from "@/pages/site/About";
import Terms from "@/pages/site/Terms";
import Privacy from "@/pages/site/Privacy";
import B2B from "@/pages/site/B2B";
import Storefront from "@/pages/site/Storefront";
import PatientPortal from "@/pages/patient/PatientPortal";
import DoctorPortal from "@/pages/doctor/DoctorPortal";
import AdminConsole from "@/pages/admin/AdminConsole";
import SupportPortal from "@/pages/support/SupportPortal";
import SetPassword from "@/pages/site/SetPassword";
import Checkout from "@/pages/site/Checkout";
import OrderConfirmation from "@/pages/site/OrderConfirmation";
import MyOrders from "@/pages/site/MyOrders";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <div className="App">
      <I18nProvider>
      <AuthProvider>
        <MessagingProvider>
          <CartProvider>
          <BrowserRouter>
            <GlobalTranslator />
            <FloatingLanguageSwitcher />
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/book" element={<Book />} />
                <Route path="/second-opinion" element={<SecondOpinion />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/specialties" element={<Specialties />} />
                <Route path="/specialty/:id" element={<SpecialtyDetail />} />
                <Route path="/doctor/:id" element={<DoctorProfile />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/b2b" element={<B2B />} />
                <Route path="/pharmaceuticals" element={<Storefront kind="pharmaceutical" />} />
                <Route path="/nutraceuticals" element={<Storefront kind="nutraceutical" />} />
                <Route path="/b2b/checkout" element={<Checkout />} />
                <Route path="/b2b/order/:oid" element={<OrderConfirmation />} />
                <Route path="/b2b/orders" element={<MyOrders />} />
              </Route>
              <Route path="/patient" element={<PatientPortal />} />
              <Route path="/doctor" element={<DoctorPortal />} />
              <Route path="/support" element={<SupportPortal />} />
              <Route path="/set-password" element={<SetPassword />} />
              <Route path="/admin" element={<AdminConsole />} />
            </Routes>
          </BrowserRouter>
          </CartProvider>
        </MessagingProvider>
      </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
